import Dropzone from '../../../../../../Form/Element/Dropzone';
import { useIntl } from 'react-intl';
import { useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectUserInfo } from '../../../../../../../store/selectors';
import { selectProduct } from '../../../../../../../store/selectors/products';
import { getBrokerProductSummary } from '../../../../../../../services/integrationResources';

const apiUrl = window.env.APP_BROKERFRONT_BACKEND_URI;

const Uploader = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const useQuery = () => new URLSearchParams(search);
  const query = useQuery();
  const product = query.get('product');

  const { formatMessage } = useIntl();
  const refDropzone = useRef(null);
  const refDropzoneBlack = useRef(null);
  const {
    data: { recommendationCode },
  } = useSelector(selectUserInfo);

  const { data } = useSelector(selectProduct);
  const { logo } = data;

  const defaultLogo = logo.filter(({ logoType }) => logoType === 'default');
  const darkLogo = logo.filter(({ logoType }) => logoType === 'dark');

  const hasDefaultLogo = defaultLogo.length > 0;
  const hasDarkLogo = darkLogo.length > 0;

  const handleAddFile = useCallback(async (value) => {
    try {
      const result = await getBrokerProductSummary(recommendationCode, product);
      dispatch({
        type: 'BROKER_PRODUCT_STYLES',
        payload: result.data.styles,
      });
    } catch (error) {
      console.log(error);
    }

    dispatch({
      type: 'BROKER_PRODUCT_LOGO',
      payload: value,
    });
  }, []);

  const handleFileDelete = useCallback(() => {
    handleAddFile(null);
  }, []);

  return (
    <div className='integration__uploader--wrapper'>
      <Dropzone
        isNewUI
        className='integration__uploader'
        maxFiles={1}
        ref={refDropzone}
        multiple={false}
        label={formatMessage(
          {
            id: 'File PNG, JPG, SVG max. 2 MB',
          },
          {
            br: <br />,
          }
        )}
        labelButton={formatMessage({
          id: 'Uploader select label',
        })}
        error={false}
        uploadParams={{
          product: product,
          logoType: 'default',
        }}
        addFile={handleAddFile}
        url={`${apiUrl}/api/frontend/automatic-integration/recommendation-code/${recommendationCode}/logo`}
        deleteCallback={handleFileDelete}
        hasFile={hasDefaultLogo}
        fileId={hasDefaultLogo ? defaultLogo[0]?.logoId : null}
      />

      <Dropzone
        isNewUI
        className='integration__uploader integration__uploader--dark'
        maxFiles={1}
        ref={refDropzoneBlack}
        multiple={false}
        label={formatMessage(
          {
            id: 'File PNG, JPG, SVG max. 2 MB',
          },
          {
            br: <br />,
          }
        )}
        labelButton={formatMessage({
          id: 'Uploader select label',
        })}
        error={false}
        uploadParams={{
          product: product,
          logoType: 'dark',
        }}
        addFile={handleAddFile}
        url={`${apiUrl}/api/frontend/automatic-integration/recommendation-code/${recommendationCode}/logo`}
        deleteCallback={handleFileDelete}
        hasFile={hasDefaultLogo}
        fileId={hasDarkLogo ? darkLogo[0]?.logoId : null}
      />
    </div>
  );
};

export default Uploader;
